import * as React from "react";
import {
    BoxIsolatedContent,
    ContentTop16,
    ContentXsTop,
    FlexColumn,
    FlexColumnCentered
} from "../../components/ui/Content";
import {LogoId} from "../../icon/Icon";
import {LeftText} from "../../components/Font";
import {ButtonPrimary} from "../../components/ui/Button";
import {LanguageSelector} from "./LanguageSelector";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import {LocalStorageEnum} from "../../enum/localStorage";

export const Welcome = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const {search} = useLocation()
    return <div className={'background body1'}>
        <FlexColumnCentered className={'box-isolated'}>
            <BoxIsolatedContent>
                <LogoId/>
                <FlexColumn>
                    <ContentTop16>
                        <LeftText>
                            {t('auth.authText1')}
                        </LeftText>
                        <ContentXsTop>
                            <LeftText>
                                {t('auth.authText2')}
                            </LeftText>
                        </ContentXsTop>
                        <ContentXsTop>
                            <LeftText>
                                {t('auth.authText3')}
                            </LeftText>
                        </ContentXsTop>
                    </ContentTop16>
                </FlexColumn>

                <ButtonPrimary onClick={() => {
                    localStorage.setItem(LocalStorageEnum.sawUpdate, 'true')
                    navigate(`/sign-in${search}`)
                }
                }>{t('auth.continue')}
                </ButtonPrimary>
            </BoxIsolatedContent>
            <LanguageSelector/>
        </FlexColumnCentered>
    </div>
}
export default Welcome
